import React from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterPincodeAdd = ({ buttonConfig, isButtonClicked }) => {
  const addHandler = buttonConfig.addHandler;

  const closeHandler = buttonConfig.closeAddModal;

  const schema = z.object({
    pincode: z.string().nonempty(),
    city: z.string().nonempty(),
    short_name: z.string(),
    district: z.string().nonempty(),
    state: z.string().nonempty(),
    state_code: z.string().nonempty(),
    state_ut: z.string(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      short_name: "-",
      state_ut: "-",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  form.watch();

  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };
    console.log(updatedData);
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-sm:top-[10%] sm:top-1/2 sm:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Add Pincode`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)} className="">
          {/* row 1 */}
          <div className="max-sm:scrollbar-custom overflow-x-hidden max-sm:h-[560px] max-sm:overflow-y-scroll sm:overflow-hidden ">
            <div className="w-full gap-2 lg:flex">
              <div className="w-full gap-2 max-sm:space-y-3 sm:flex">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">Pincode *</label>
                  <input
                    placeholder=""
                    {...form.register("pincode")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.pincode && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">City *</label>
                  <input
                    placeholder="Panipat"
                    {...form.register("city")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.city && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
              <div className="w-full gap-2 max-lg:mt-3 max-sm:space-y-3 sm:flex">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    State / UT *
                  </label>
                  <input
                    placeholder="Haryana"
                    {...form.register("state")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.state && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    State Code *
                  </label>
                  <input
                    placeholder=""
                    {...form.register("state_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.state_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="items-end gap-2 lg:mt-8 lg:flex ">
              <div className="w-full gap-2 max-lg:mt-3 max-sm:space-y-3 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">District *</label>
                  <input
                    placeholder=""
                    {...form.register("district")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.district && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className="flex h-full  w-full flex-col gap-2">
                  <label className="text-[#636363]">Status</label>
                  <div
                    className={cn(
                      " h-full w-full rounded bg-neutral-100 px-2 py-[9px]",
                      errors.status && "border-[1px] border-red-300",
                    )}
                  >
                    <select
                      {...form.register("status")}
                      className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                      defaultValue={true}
                    >
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="w-full gap-2 max-lg:mt-3 max-sm:space-y-3 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Start date *</label>

                    <div className="relative flex w-full">
                      <input
                        type="date"
                        {...form.register("eff_start_date")}
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                          errors.eff_start_date &&
                            "border-[1px] border-red-300",
                        )}
                      />
                      <img
                        src={datePickerIcon}
                        className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>End date</label>

                    <div className="relative flex w-full">
                      <input
                        type="date"
                        {...form.register("eff_end_date")}
                        min={form.getValues("eff_start_date")}
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                          errors.eff_end_date && "border-[1px] border-red-300",
                        )}
                      />
                      <img
                        src={datePickerIcon}
                        className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-between gap-2 max-lg:[&>button]:w-1/2 max-sm:[&>button]:w-full lg:[&>button]:w-1/4">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
          </div>
        </form>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterPincodeAdd;
